// extracted by mini-css-extract-plugin
export default {"root":"Deposit-module_root_de79ab","icon":"Deposit-module_icon_ef9593"};